export { default } from './HeroView';



// WEBPACK FOOTER //
// ./src/components/views/HeroView/index.js